var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalEditionRol",
      attrs: { title: "Copiar rol Rol", "hide-footer": "", centered: "" }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.isSaving } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "nombre" } }, [_vm._v("Nombre")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rol.name,
                    expression: "rol.name"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "nombre",
                  placeholder: "Nombre del rol"
                },
                domProps: { value: _vm.rol.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.rol, "name", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: !_vm.isValid },
                on: { click: _vm.saveRol }
              },
              [_vm._v(" Guardar ")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }